import http from '../lib/http'

class Book {
  constructor () {
    this.$http = http
  }

  /**
   * 医院列表
   * @returns {Promise<Array>}
   */
  async areaHosList () {
    const { code, list } = await this.$http('smarthos.yygh.ApiPlatBaseService.areaHosList', {})
    if (code === '0') return list
    return []
  }

  /**
   * 医院详情
   * @param yyid
   * @returns {Promise<*>}
   */
  async areaHosInfo (yyid) {
    const list = await this.areaHosList()
    return list.find(r => r.yyid === yyid)
  }

  /**
   * 医院科室列表
   * @param hosId
   * @returns {Promise<Array>}
   */
  async deptList (hosId) {
    const { code, list } = await this.$http('smarthos.yygh.ApiDepartmentService.oneClassDepartmentList', { hosId })
    if (code === '0') return list
    return []
  }

  /**
   * 订单列表
   * @param hzid
   * @param pageNum
   * @param pageSize
   * @returns {Promise<*>}
   */
  async list (hzid, pageNum = 1, pageSize = 10) {
    let { code, list, page } = await this.$http('smarthos.yygh.apiOrderService.ghBespeakList', {
      hzid,
      pageNum,
      pageSize
    })
    if (code === '0') {
return {
      list: list.map(r => this.handlerOrder(r)), page
    }
}
    return { list: [] }
  }

  /**
   * 订单详情
   * @param orderid
   * @param id
   * @param hzid
   * @param orgid
   * @returns {Promise<{}>}
   */
  /* async info({ orderid, id, hzid, orgid }) {
    let data = {
      hzid,
      orgid
    }, meta;
    if (orderid != 'null') meta = { orderid };
    if (id != 'null') meta = { id };
    console.log('meta', meta);
    const { code, list } = await this.$http('smarthos.yygh.apiOrderService.ghBespeakList', { ...data, ...meta });
    if (code === '0') return this.handlerOrder(list[0]);
    return {};
  } */

  /**
   * 取消订单
   * @param orderid
   * @param pass
   * @param orgid
   * @returns {Promise<void>}
   */
  async cancel ({ orderid, pass, orgid }) {
    const { code } = await this.$http('smarthos.yygh.apiOrderService.cancel', { orderid, pass, orgid })
    return code === '0'
  }

  handlerOrder (data) {
    // 处理时间显示
    data._numdate = data.numdate.substring(0, 4) + '-' + data.numdate.substring(4, 6) + '-' + data.numdate.substring(6, 8)
    // 上下午标识
    data._ampm = BOOK_AMPM[data.ampm]
    // 订单类型
    data._type = data.id ? '当天挂号' : data.orderid ? '预约挂号' : ''
    if (data.id) {
      data._state = BOOK_TODAY_STATE[data.orderState]
    }
    if (data.orderid) {
      data._state = BOOK_STATE[data.orderState]
    }
    return data
  }

  /**
   * 当日挂号支付
   * @param openid
   * @param ddid
   * @param orgid
   * @param paymode
   * @returns {Promise<{}>}
   */
  async todayPay ({ openid, ddid, orgid, paymode = 4 }) {
    const { code, keyword } = await this.$http('smarthos.yygh.ApiyGHpaymentService.ghPayment', {
      openid, ddid, orgid, paymode
    })
    if (code === '0') return keyword
    return {}
  }

  /**
   * 预约取号预支付
   * @param orgid
   * @param numid
   * @param patid
   * @param orderid
   * @param jzkh
   * @returns {Promise<void>}
   */
  async prepay ({ orgid, numid, patid, orderid, jzkh }) {
    // type=yyqh&orgid=888&numid=0d69e81fa88fd7152fa718b76b228996&patid=25325760512&orderid=25165&jzkh=310017
    const { code, obj } = await this.$http('smarthos.yygh.apiOrderService.prePayment', {
      orgid,
      numid,
      patid,
      orderid,
      jzkh
    })
    if (code === '0') return obj
    else return {}
  }
}

export const bookService = new Book()



// WEBPACK FOOTER //
// ./src/services/book.js